export default {
  design: {
    title: 'Design',
  },

  detail: {
    leaveConfirmation: 'Are you sure you want to leave? All adjustments will be lost.',
    leaveTitle: 'Confirmation',
  },

  filters: {
    cw_class_kettle: 'CW Class Central Heating Kettle',
    gas_connection_type: 'Gas Connection Type',
    heat_pump_power: 'Heat Pump Power',
    heat_pump_series: 'Heat Pump Series',
    heat_pump_type: 'Heat Pump Type',
    kettle_series: 'Kettle Series',
    kettle_type: 'Kettle Type',
  },

  info: {
    products: 'Main products in this configuration',
    sap: 'Product code',
    select: 'Select system',
  },

  overview: {
    noData: 'No systems are found',
  },

  quote: {
    calculation: {
      subtotalExclVAT: 'Subtotal (excl. VAT):',
      subtotalInclVAT: 'Subtotal (incl. VAT):',
      total: 'Total:',
      vat: 'VAT:',
    },
    columns: {
      amount: 'Amount',
      price: 'Price',
      name: 'Name',
      serial_number: 'Product code',
      subtotal: 'Subtotal',
      vat_percentage: 'VAT %',
      vat_total: 'VAT €',
    },
    system: 'System',
    title: 'Quote',
  },

  share: {
    addMessage: 'Add message',
    billMaterials: 'Bill of materials',
    date: 'Date',
    defaultMessage: 'Dear, \n\nPlease find the quotation as an attachement within this e-mail.\nIf you have any further remarks, feel free to contact us. \n\nKinds regards,',
    download: 'Download',
    editSubject: 'Edit email subject',
    editSubjectPlaceholder: 'Enter a subject...',
    emailPlaceholder: 'Enter an email address...',
    failure: 'Something went wrong. Please try again later.',
    loading: 'Loading...',
    quote: 'Quote',
    quoteNumber: 'Quote number',
    sendDuplicate: 'Send duplicate to me',
    shareViaMail: 'Share via e-mail',
    success: 'Project was successfully sent.',
    systemSketch: 'System Sketch',
    title: 'Share via email',
    totalAmount: 'Total amount',
    validUntil: 'Valid until',
  },

  sorting: {
    nameAsc: 'Name A - Z',
    nameDesc: 'Name Z - A',
    priceAsc: 'Price low - high',
    priceDesc: 'Price high - low',
  },

  title: 'Systems',

};



// WEBPACK FOOTER //
// ./js/lang/en/systems.js